<template>
<div class="ztbox">
	<!--<div class="ztheader">
	</div>-->
	<div class="ztcenter">
		   <div class="centerlist">
		      <div class="centerone" style="width:50%;">
		        <div class='onetitle'>工作室建设</div>
		        <div class="onebg">
		           <div class="onetop">
		           	<div class="topitem">
		           		<span class="span">全部</span>
		           		<div class="topright">
		           			<p class="righttop">102<span>个</span></p>
		           		</div>
		           	</div>
		           	<div class="topitem">
		           		<span class="span">职业本科</span>
		           		<!---->
		           		<div class="topright">
		           			<!-- <p class="righttop">15<span>个</span></p> -->
							 <p class="righttop">2<span>个</span></p>
		           			<p class="rightbottom">2/2所</p>
		           		</div>
		           	</div>
		           	<div class="topitem">
		           		<span class="span">高职院校</span>
		           		<!--<span></span>-->
		           		<div class="topright">
		           			<!-- <p class="righttop">78<span>个</span></p> -->
							<p class="righttop">44<span>个</span></p>
		           			<p class="rightbottom">22/50所</p>
		           		</div>
		           	</div>
		           	<div class="topitem">
		           		<span class="span">中职院校</span>
		           		<!--<span></span>-->
		           		<div class="topright">
		           			<!-- <p class="righttop">19<span>个</span></p> -->
							<p class="righttop">47<span>个</span></p>
		           			<p class="rightbottom">15/212所</p>
		           		</div>
		           	</div>
		           	<div class="topitem">
		           		<span class="span">技工院校</span>
		           		<div class="topright">
		           			<!-- <p class="righttop">0<span>个</span></p> -->
							 <p class="righttop">9<span>个</span></p>
		           			<p class="rightbottom">0/10所</p>
		           		</div>
		           	</div>
		           </div>
		           <div class="onebottom">
		           	   <div class="bottomleft">
			           	   	<div class="lefttitle">
			           	   		<span class="leftspan"></span>
			           	   		<img src="" class="leftimg" alt="" />
			           	   	</div>
		           	   	   <div class="onebox" id="2dzzts"></div>
		           	   </div>
		           	   <div class="bottomright">
		           	   		<div class="lefttitle">
			           	   		<span class="leftspan" >各地市工作室建设</span>
			           	   		<img src="" class="leftimg" alt="" />
			           	     </div>
		           	   	   <div class="onebox" style="border-left:1px solid #093076" id="gxt"></div>
		           	   </div>
		           </div>
		        </div>
		      </div>
		       <div class="centerone">
		          <!-- <div class='onetitle'>思政工作室资金预算</div> -->
				  <div class='onetitle'>各地市工作室建设</div>
		          <div class="onebg"  id="zzt">
		          	 <!-- <div class="bgzt"> 
		          	 	 <div class="ztleft">
		          	 	 	<div class="leftitem">
		          	 	 		<p class="lefttext">预算金额</p>
		          	 	 		<p class="lefttext"><span>****</span>万元</p>
		          	 	 	</div>
		          	 	 	<div class="leftitem">
		          	 	 		<p class="lefttext">省补贴</p>
		          	 	 		<p class="lefttext"><span>****</span>万元</p>
		          	 	 	</div>
		          	 	 	<div class="leftitem">
		          	 	 		<p class="lefttext">地方补贴</p>
		          	 	 		<p class="lefttext"><span>****</span>万元</p>
		          	 	 	</div>
		          	 	 	<div class="leftitem">
		          	 	 		<p class="lefttext">学校自筹</p>
		          	 	 		<p class="lefttext"><span>****</span>万元</p>
		          	 	 	</div>
		          	 	 	<div class="leftitem">
		          	 	 		<p class="lefttext">其他来源</p>
		          	 	 		<p class="lefttext"><span>****</span>万元</p>
		          	 	 	</div>
		          	 	 </div>
		          	 	 <div class="ztright" id="type">
		          	 	 	
		          	 	 </div>
		          	 </div> -->
		          </div>
		       </div>
		   </div>
		   <div class="centerlist centerlist1">
		   	     <div class="centerone" style="width:50%;">
		   	     	 <!-- <div class='onetitle'>各地市工作室建设</div> -->
					<div class='onetitle'>各地市教研情况分析</div>
		   	     	<div class="onebg onebg1">
		   	     		 <div class="onesj" id="zzt1"></div>
		   	     	</div>
		   	    </div> 	
		   	     <div class="centerone">
		   	     	 <!-- <div class='onetitle'>思政工作室资金使用</div> -->
					  <div class='onetitle'>思政工作室启用分析</div>
		   	     	<div class="onebg onebg1" id="zzt2">
		   	     		 <!-- <div class="bg1-left">
		   	     		 	 <div class="bg1-top">
		   	     		 	 	 <p class="bg1-top-text">实际资金使用：</p>
		   	     		 	 	 <p class="bg1-top-text"><span>****</span>万元</p>
		   	     		 	 </div>
		   	     		 	 <div  class="bg1-bottom">
		   	     		 	 	<div class="bg1-bottom-item">
		   	     		 	 		 <div class="bg1-bottom-img">100%</div>
		   	     		 	 		 <p class="bg1-bottom-text">省资金使用率</p>
		   	     		 	 	</div>
		   	     		 	 <div class="bg1-bottom-item">
		   	     		 	 		 <div class="bg1-bottom-img">100%</div>
		   	     		 	 		 <p class="bg1-bottom-text">地方资金使用率</p>
		   	     		 	 	</div>
		   	     		 	 <div class="bg1-bottom-item">
		   	     		 	 		 <div class="bg1-bottom-img">100%</div>
		   	     		 	 		 <p class="bg1-bottom-text">学校自筹资金使用率</p>
		   	     		 	 	</div>
		   	     		 	 	<div class="bg1-bottom-item">
		   	     		 	 		 <div class="bg1-bottom-img">100%</div>
		   	     		 	 		 <p class="bg1-bottom-text">其他资金使用率</p>
		   	     		 	 	</div>
		   	     		 	 </div>
		   	     		 </div>
		   	     		 <div class="bg1-right">
		   	     		 	     <div class="lefttitle">
			           	   		<span class="leftspan" style="padding-left:20px;">各地市省资金使用情况</span>
			           	   		<img src="" class="leftimg" alt="" />
			           	     </div>
		           	   	   <div class="onebox" style="height:160px;" id="zztd"></div>
		   	     		 </div> -->
		   	     	</div>
		   	    </div> 
		   </div>
	
			 <div class="centerlist centerlist1">
		   	     <div class="centerone" style="width:45%;">
		   	     	 <div class='onetitle'>思政工作室成果</div>
		   	     	<div class="onebg onebg1">
		   	     		 <div class="zhtleft" id="bt">
		   	     		 	  
		   	     		 </div>
		   	     		  <div class="zhtright">
		   	     		 	  <table class="tables">
		   	     		 	  	<thead>
		   	     		 	  		<tr>
		   	     		 	  			<th>地区</th>
		   	     		 	  			<th>成果数量</th>
		   	     		 	  			<th>地区</th>
		   	     		 	  			<th>成果数量</th>
		   	     		 	  		</tr>
		   	     		 	  	</thead>
		   	     		 	  	<tbody>
		   	     		 	  		 <tr>
		   	     		 	  		    <td>太原</td>
		   	     		 	  		 		<td>587</td>
		   	     		 	  		 		<td>大同</td>
		   	     		 	  		 		<td>375</td>
		   	     		 	  		 </tr>
		   	     		 	  		 <tr>
		   	     		 	  		    <td>阳泉</td>
		   	     		 	  		 		<td>483</td>
		   	     		 	  		 		<td>长治</td>
		   	     		 	  		 		<td>553</td>
		   	     		 	  		 </tr>
		   	     		 	  		 <tr>
		   	     		 	  		    <td>晋城</td>
		   	     		 	  		 		<td>368</td>
		   	     		 	  		 		<td>朔州</td>
		   	     		 	  		 		<td>457</td>
		   	     		 	  		 </tr>
		   	     		 	  		 <tr>
		   	     		 	  		    <td>晋中</td>
		   	     		 	  		 		<td>658</td>
		   	     		 	  		 		<td>运城</td>
		   	     		 	  		 		<td>459</td>
		   	     		 	  		 </tr>
		   	     		 	  		 <tr>
		   	     		 	  		    <td>忻州</td>
		   	     		 	  		 		<td>777</td>
		   	     		 	  		 		<td>临汾</td>
		   	     		 	  		 		<td>569</td>
		   	     		 	  		 </tr>
		   	     		 	  		 <tr>
		   	     		 	  		    <td>吕梁</td>
		   	     		 	  		 		<td>425</td>
		   	     		 	  		 		<td>总计</td>
		   	     		 	  		 		<td style="color:#FFCC00;">5711</td>
		   	     		 	  		 </tr>
		   	     		 	  	</tbody>
		   	     		 	  </table>
		   	     		 </div>
		   	     	</div>
		   	    </div> 	
		   	     <div class="centerone" style="width:26%">
		   	     	 <!-- <div class='onetitle onetitle1'>思政工作室中高职成果统计
		   	     	 	 <a-select
				            default-value="全部"
				            style="width: 100px; margin-left: 10px;"
				            @change="handleChange"
				            :dropdownClassName="'customClass'"
				          >
				            <a-select-option value="全部">全部</a-select-option>
				          </a-select>
		   	     	 </div>
		   	     	<div class="onebg onebg1">
		   	     		 <div class="onesj" id="mgt"></div>
		   	     	</div> -->
					<div class='onetitle onetitle1'>思政实践基地建设情况 </div>
		   	     	<div class="onebg onebg1">
		   	     		 <div class="onesj" id="mgt"></div>
		   	     	</div> 
		   	    </div>
		   	     <div class="centerone" style="width:27%">
		   	     	 <div class='onetitle onetitle1'>工作室展示</div>
		   	     	<div class="onebg onebg1" >
		   	     		 <div class="zhlist">
		   	     		 	 <div class="zhitem">
		   	     		 	 	 <img src="@/assets/images/bigdatas/zhs.png" class="zhimg" alt="" />
		   	     		 	 	 <span class="zhspan1">三爱四善</span>
		   	     		 	 	 <span class="zhspan2">【山西水利职业技术学院】</span>
		   	     		 	 </div>
		   	     		 	 <div class="zhitem">
		   	     		 	 	 <img src="@/assets/images/bigdatas/zhs.png" class="zhimg" alt="" />
		   	     		 	 	 <span class="zhspan1">医心向党 护佑健康</span>
		   	     		 	 	 <span class="zhspan2">【运城护理职业学院】</span>
		   	     		 	 </div>
		   	     		 	  <div class="zhitem">
		   	     		 	 	 <img src="@/assets/images/bigdatas/zhs.png" class="zhimg" alt="" />
		   	     		 	 	 <span class="zhspan1">修身 琢业</span>
		   	     		 	 	 <span class="zhspan2">【长治技师学院】</span>
		   	     		 	 </div>
		   	     		 	  <div class="zhitem">
		   	     		 	 	 <img src="@/assets/images/bigdatas/zhs.png" class="zhimg" alt="" />
		   	     		 	 	 <span class="zhspan1">原导网络思政工作室</span>
		   	     		 	 	 <span class="zhspan2">【晋中职业技术学院】</span>
		   	     		 	 </div>
		   	     		 </div>
		   	     	</div>
		   	    </div> 
		  </div>
	</div>
</div>
</template>

<script>
import * as echarts from 'echarts';
import HighCharts from "highcharts";
export default{
	data(){
		return {
			
		}
	},
//	metaInfo() {
//  return {
//    meta: [
//      {
//        name: 'viewport',
//        content: this.getViewportContent()
//      }
//    ]
//  };
//  },
	mounted(){
		  let VALUE1 = ['职业本科', '高职院校', '中职院校', '技工院校'];
			let VALUE2 = [0,21,12,4];
			let VALUE3 = [1,9,26,2];
			let VALUE4 = [1,10,8,3];
			let VALUE5 = ["2021", '2022', "2023"];
			this.zzt2d("2dzzts", VALUE1, VALUE2, VALUE3, VALUE4, VALUE5);	
		
			
			let VALUE6 = ['太原', '大同','阳泉','长治','晋城','朔州','晋中','运城','忻州','临汾','吕梁'];
			let VALUE7 = [12,1,1,4,0,1,2,1,2,1,2];
			let VALUE8 = [15,3,1,3,0,2,4,4,1,2,3];
			let VALUE9 = [18,3,0,3,1,0,5,3,0,3,1];
			let VALUE10 = ["2023", '2022', "2021"];
			this.zzt2ds("zzt", VALUE6, VALUE7, VALUE8, VALUE9, VALUE10);	
			let VALUE77 = [12,1,1,4,0,1,2,1,2,1,2];
			let VALUE88 = [15,3,1,3,0,2,4,4,1,2,3];
			let VALUE99 = [18,3,0,3,1,0,5,3,0,3,1];
			let VALUE100 = ["2023", '2022', "2021"];
			this.zzt2ds("zzt1", VALUE6, VALUE77, VALUE88, VALUE99, VALUE100);	
//			let VALUE11 = [100,80,100,59,100,100,100,100,78, 80,100];
			let VALUE11 = [10.92,8.82,8.4,9.45,8.82,9.03,9.03,8.61,9.24, 7.98,9.66];
		    // this.zzt2dd("zztd", VALUE6,VALUE11);	
		  let VALUE101= ["开启", '关闭'];
		  this.zzt2dds("zzt2", VALUE6, VALUE77, VALUE88, VALUE101);	
		  this.gxt();
		  if(window.innerWidth>1440){
			// this.getMyChart6('240');	
			 this.getMyChart5('140');
			//  this.mgtdown([50,100]);
			this.getszjd('mgt');
		  }else{
			// this.getMyChart6('160');
			 this.getMyChart5('100');
			//  this.mgtdown([20,60]);
			this.getszjd('mgt');
		 }
//		 if (window.devicePixelRatio > 1) {
//		  // 计算需要缩放的比例
//		  const scale = 1 / window.devicePixelRatio;
//		  // 设置 viewport 的缩放比例
//		  const viewportMetaTag = document.querySelector('meta[name="viewport"]');
//		  if (viewportMetaTag) {
////		  	width=device-width,initial-scale=1
//		    viewportMetaTag.content = `width=device-width,initial-scale=${scale},maximum-scale=${scale},user-scalable=no`;
//		  }
//		}
	},	methods:{
//		getViewportContent() {
//	      if (window.devicePixelRatio > 1) {
//	        const scale = 1 / window.devicePixelRatio;
//	        console.log("11111");
//	        return `width=device-width, initial-scale=${scale}, maximum-scale=${scale}, user-scalable=no`;
//	      } else {
//	        return 'width=device-width, initial-scale=1.0';
//	      }
//	    },
		getszjd(id){
			let value = ['太原', '大同','阳泉','长治','晋城','朔州','晋中','运城','忻州','临汾','吕梁'];
			let value1 = [15,10,8,8,8,9,9,8,9, 7,9];
			var myChart = echarts.init(document.getElementById(id));
				let option = {
					grid: {
						containLabel: true,
						left: 5,
						right: 15,
						bottom: 15,
						top: 30,
					},
					legend: {
						show:false,
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					xAxis: {
						type: 'category',
						data: value,
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},
							formatter: function(value) {
								let rowMAx = 4
								let overValue = ''
								for(let i = 0; i < value.length; i++) {
									if((i % rowMAx == 0) && (i != 0)) {
										overValue += '\n'
										overValue += value[i]
									} else {
										overValue += value[i]
									}
								}
								return overValue
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#3c71c1",
							}
						},
					},
					yAxis: {
						type: 'value',
						name: '',
						nameTextStyle:{
							color:'#68A8CC',
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},
 							formatter: '{value}'
						},
						axisLine: {
							show: false,
							lineStyle: {
								  color: "#68A8CC",
							}
						},
						splitLine: { // y 轴分隔线配置
						show: true, // 是否显示分隔线
						lineStyle: {
							color: '#68A8CC', // 分隔线颜色
						}
					}     	
					},
					series: [{
							name: '思政实践基地个数',
							data: value1,
							type: 'bar',
							barWidth: "15",
							barGap:'30%',
							itemStyle: {
								normal: {
									borderColor: '#0083E5', // 边框颜色
                 					 borderWidth: 2, 
									color: function(params) { // 内部颜色
                       return '#0055A8';
                  }
								}
							},
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
								formatter: '{c}'
							}
					   },
					]
				};
				myChart.clear();
				myChart.setOption(option);
		},
		handleChange(){
			
		},
		gxt(){
			    var myChart = echarts.init(document.getElementById('gxt'));
			    let option = {
					  title: {
					    text: ''
					  },
//					  polar:{
//                       center: ['10%', '10%'] // 水平居中并向右移动 10%，垂直居中
//                     },
					  legend: {
					    data: ['太原', '大同','阳泉','长治','晋城','朔州','晋中','运城','忻州','临汾','吕梁'],
					    orient: 'vertical', // 设置图例垂直排列
        			left: 'left',
        			textStyle: {
			            color: '#E9EAEF' // 设置图例文本颜色
			        },
			        itemWidth: 12, // 设置图例标记的宽度
			        itemHeight: 8,
					  },
					  radar: {
					    // shape: 'circle',
					    indicator: [
					      { name: '职业本科', max:80},
					      { name: '技工院校', max:80},
					      { name: '中职院校',max:80 },
					      { name: '高职院校', max:80},
					    ],
					    shape: 'polygon',
					        radius: '60%',
					        splitNumber: 5,
					        name: {
					            textStyle: {
					                color: '#fff' // 指示器名称的文字颜色
					            }
					        },
					        axisLine: {
					            lineStyle: {
					                color: '#004779' // 中间x轴和y轴的颜色
					            }
					        },
					        splitLine: {
					            lineStyle: {
					                color: ['#004779', '#004779', '#004779'] // 分隔线颜色
					            }
					        },
					        splitArea: { // 区域填充样式
					            show: true, // 显示分隔区域
					            areaStyle: {
					                color: ['rgba(0,0,0,0)', 'RGBA(0, 46, 113,0.5)'] // 分割区域的颜色数组
					            }
					       }
					  },
					  tooltip: {
                 trigger: 'item'
            },
					  series: [
					    {
					      name: 'Budget vs spending',
					      type: 'radar',
					      data: [
					        {
					          value: [2, 4, 9, 30],
					          name: '太原',
					          itemStyle: {
                                   color: '#5470C6',
                              },
					        },
					        {
					          value: [0, 2, 3, 2],
					          name: '大同',
					          itemStyle: {
                       color: '#91CC75',
                    },
					        },
					        {
					          value: [0, 0, 1, 1],
					          name: '阳泉',
					          itemStyle: {
                       color: '#FAC858',
                    },
					        },
					         {
					          value: [0, 1, 6, 3],
					          name: '长治',
					          itemStyle: {
                       color: '#EE6666',
                    },
					        },
					        {
					          value: [0, 1, 0, 0],
					          name: '晋城',
					          itemStyle: {
                       color: '#73C0DE',
                    },
					        },
					        {
					          value: [0, 0, 1, 2],
					          name: '朔州',
					          itemStyle: {
                       color: '#3BA272',
                    },
					        },
					        {
					          value: [0, 0, 8, 3],
					          name: '晋中',
					          itemStyle: {
                       color: '#FC8452',
                    },
					        },
					        {
					          value: [0, 0, 6, 2],
					          name: '运城',
					          itemStyle: {
                       color: '#9A60B4',
                    },
					        },
					        {
					          value: [0, 0, 3, 0],
					          name: '忻州',
					          itemStyle: {
                       color: '#1E19D1',
                    },
					        },
					        {
					          value: [0, 1, 4, 1],
					          name: '临汾',
					          itemStyle: {
                       color: '#7017DD',
                    },
					        },
					        {
					          value: [0, 0, 5, 1],
					          name: '吕梁',
					          itemStyle: {
                       color: '#457FAF',
                    },
					        },
					      ]
					    }
					  ]
					};
					myChart.clear();
				myChart.setOption(option);
		},
		zzt2d(id, value, value1, value2, value3, VALUE10) {
				var myChart = echarts.init(document.getElementById(id));
				let option = {
					grid: {
						containLabel: true,
						left: 5,
						right: 15,
						bottom: 15,
						top: 48,
					},
					legend: {
						data: VALUE10,
						textStyle: {
							color: '#ffffff' //字体颜色
						},
						origent: 'right',
						top:0,
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					xAxis: {
						type: 'category',
						data: value,
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},
							formatter: function(value) {
								let rowMAx = 4
								let overValue = ''
								for(let i = 0; i < value.length; i++) {
									if((i % rowMAx == 0) && (i != 0)) {
										overValue += '\n'
										overValue += value[i]
									} else {
										overValue += value[i]
									}
								}
								return overValue
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#3c71c1",
							}
						},
					},
					yAxis: {
						type: 'value',
						name: '',
						nameTextStyle:{
							color:'#68A8CC',
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},

						},
						axisLine: {
							show: false,
							lineStyle: {
								  color: "#68A8CC",
							}
						},
						splitLine: { // y 轴分隔线配置
	            show: true, // 是否显示分隔线
	            lineStyle: {
	                color: '#68A8CC', // 分隔线颜色
	            }
            }     
					},
					series: [{
							name: VALUE10[0],
							data: value1,
							type: 'bar',
							barWidth: "15",
							barGap:'40%',
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#55FBFE' // 0% 处的颜色
									}, {
										offset: 1,
										color: '#021BAC' // 100% 处的颜色
									}], false),
								}
							},
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
							}

						},
						{
							name: VALUE10[1],
							data: value2,
							type: 'bar',
							barWidth: "15",
							barGap:'40%',
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#A7FC76' // 0% 处的颜色
									}, {
										offset: 1,
										color: '#068203' // 100% 处的颜色
									}], false),
								}
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
							}

						},
						{
							name: VALUE10[2],
							data: value3,
							type: 'bar',
							barGap:'40%',
							barWidth: "15",
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#FFFC76' // 0% 处的颜色
									}, {
										offset: 1,
										color: '#FF4A02' // 100% 处的颜色
									}], false),
								}
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
							}

						}
					]
				};
				myChart.clear();
				myChart.setOption(option);
		},
		zzt2ds(id, value, value1, value2, value3, VALUE10) {
				var myChart = echarts.init(document.getElementById(id));
				let option = {
					grid: {
						containLabel: true,
						left: 5,
						right: 15,
						bottom: 15,
						top: 48,
					},
					legend: {
						data: VALUE10,
						textStyle: {
							color: '#ffffff' //字体颜色
						},
//						origent: 'right',
						top:0,
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					xAxis: {
						type: 'category',
						data: value,
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},
							formatter: function(value) {
								let rowMAx = 4
								let overValue = ''
								for(let i = 0; i < value.length; i++) {
									if((i % rowMAx == 0) && (i != 0)) {
										overValue += '\n'
										overValue += value[i]
									} else {
										overValue += value[i]
									}
								}
								return overValue
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#3c71c1",
							}
						},
					},
					yAxis: {
						type: 'value',
						name: '',
						nameTextStyle:{
							color:'#68A8CC',
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},

						},
						axisLine: {
							show: false,
							lineStyle: {
								  color: "#68A8CC",
							}
						},
						splitLine: { // y 轴分隔线配置
	            show: true, // 是否显示分隔线
	            lineStyle: {
	                color: '#68A8CC', // 分隔线颜色
	            }
            }     
					},
					series: [{
							name: VALUE10[0],
							data: value1,
							type: 'bar',
							barWidth: "15",
							barGap:'30%',
//							itemStyle: {
//								normal: {
//									borderColor: '#0083E5', // 边框颜色
//                borderWidth: 2, 
//									color: '#0055A8',
//								}
//							},
 							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#55FBFE' // 0% 处的颜色
									}, {
										offset: 1,
										color: '#021BAC' // 100% 处的颜色
									}], false),
								}
							},
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
							}

						},
						{
							name: VALUE10[1],
							data: value2,
							type: 'bar',
							barWidth: "15",
							barGap:'30%',
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
//							itemStyle: {
//								normal: {
//									borderColor: '#B47418', // 边框颜色
//                borderWidth: 2, 
//									color: '#805828',
//								}
//							},
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#A7FC76' // 0% 处的颜色
									}, {
										offset: 1,
										color: '#068203' // 100% 处的颜色
									}], false),
								}
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
							}

						},
						{
							name: VALUE10[2],
							data: value3,
							type: 'bar',
							barGap:'30%',
							barWidth: "15",
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
//							itemStyle: {
//								normal: {
//									borderColor: '#1FD749', // 边框颜色
//                borderWidth: 2, 
//									color: '#10764D',
//								}
//							},
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#FFFC76' // 0% 处的颜色
									}, {
										offset: 1,
										color: '#FF4A02' // 100% 处的颜色
									}], false),
								}
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
							}

						}
					]
				};
				myChart.clear();
				myChart.setOption(option);
		},
		zzt2dd(id, value, value1){
			var myChart = echarts.init(document.getElementById(id));
				let option = {
					grid: {
						containLabel: true,
						left: 5,
						right: 15,
						bottom: 15,
						top: 30,
					},
					legend: {
						show:false,
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					xAxis: {
						type: 'category',
						data: value,
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},
							formatter: function(value) {
								let rowMAx = 4
								let overValue = ''
								for(let i = 0; i < value.length; i++) {
									if((i % rowMAx == 0) && (i != 0)) {
										overValue += '\n'
										overValue += value[i]
									} else {
										overValue += value[i]
									}
								}
								return overValue
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#3c71c1",
							}
						},
					},
					yAxis: {
						type: 'value',
						name: '',
						nameTextStyle:{
							color:'#68A8CC',
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},
 							formatter: '{value}%'
						},
						axisLine: {
							show: false,
							lineStyle: {
								  color: "#68A8CC",
							}
						},
						splitLine: { // y 轴分隔线配置
	            show: true, // 是否显示分隔线
	            lineStyle: {
	                color: '#68A8CC', // 分隔线颜色
	            }
            }     
					},
					series: [{
							name: '资金使用情况',
							data: value1,
							type: 'bar',
							barWidth: "15",
							barGap:'30%',
							itemStyle: {
								normal: {
									borderColor: '#0083E5', // 边框颜色
                  borderWidth: 2, 
									color: function(params) { // 内部颜色
                       return '#0055A8';
                  }
								}
							},
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
								formatter: '{c}%'
							}
					   },
					]
				};
				myChart.clear();
				myChart.setOption(option);
		},
		zzt2dds(id, value, value1, value2, VALUE10){
			var myChart = echarts.init(document.getElementById(id));
				let option = {
					grid: {
						containLabel: true,
						left: 5,
						right: 15,
						bottom: 15,
						top: 48,
					},
					legend: {
						data: VALUE10,
						textStyle: {
							color: '#ffffff' //字体颜色
						},
						origent: 'right',
						top:0,
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					xAxis: {
						type: 'category',
						data: value,
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},
							formatter: function(value) {
								let rowMAx = 4
								let overValue = ''
								for(let i = 0; i < value.length; i++) {
									if((i % rowMAx == 0) && (i != 0)) {
										overValue += '\n'
										overValue += value[i]
									} else {
										overValue += value[i]
									}
								}
								return overValue
							},
						},
						axisTick: {
							show: false,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: "#3c71c1",
							}
						},
					},
					yAxis: {
						type: 'value',
						name: '',
						nameTextStyle:{
							color:'#68A8CC',
						},
						axisLabel: {
							textStyle: {
								color: "#68A8CC"
							},

						},
						axisLine: {
							show: false,
							lineStyle: {
								  color: "#68A8CC",
							}
						},
						splitLine: { // y 轴分隔线配置
	            show: true, // 是否显示分隔线
	            lineStyle: {
	                color: '#68A8CC', // 分隔线颜色
	            }
            }     
					},
					series: [{
							name: VALUE10[0],
							data: value1,
							type: 'bar',
							barWidth: "15",
							barGap:'40%',
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#55FBFE' // 0% 处的颜色
									}, {
										offset: 1,
										color: '#021BAC' // 100% 处的颜色
									}], false),
								}
							},
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
							}

						},
						{
							name: VALUE10[1],
							data: value2,
							type: 'bar',
							barWidth: "15",
							barGap:'40%',
							showBackground: false,
							backgroundStyle: {
								color: '#04195e'
							},
							itemStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#A7FC76' // 0% 处的颜色
									}, {
										offset: 1,
										color: '#068203' // 100% 处的颜色
									}], false),
								}
							},
							label: {
								show: true,
								position: 'top',
								color: '#fff',
							}

						}
					]
				};
				myChart.clear();
				myChart.setOption(option);
		},
		getMyChart5(value) {
      HighCharts.chart("bt", {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 50,
            beta: 0,
          },
          backgroundColor: null,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#fff",
            fontSize: "10",
          },
           layout: 'horizontal', // 设置图例布局为水平布局
	        align: "center", // 图例水平对齐方式
	        verticalAlign: "bottom", // 图例垂直对齐方式// 设置图例区域宽度
//	        symbolHeight: 10, // 调整图例符号高度
//	        symbolWidth: 10, // 调整图例符号宽度
//	        symbolRadius: 0, // 调整图例符号圆角
//        itemMarginTop: 10,
          labelFormatter: function() {
            // 计算当前系列占比百分比
//          var percentage = (this.y / this.series.total) * 100;
            return this.name;
           }
        },
        plotOptions: {
          pie: {
            size: value,
            showInLegend: true,
            allowPointSelect: true, //每个扇块能否选中
            depth: 30, //饼图的厚度
            borderWidth: 2, 
            borderColor: '#FFFFFF', // 设置边框颜色为白色
            dataLabels: {
              distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
              enabled: false, //是否显示饼图的线形tip
            },
          },
        },
        series: [
          {
            // size: 150,
            name: "使用占比",
            data: [
              ["课程思政", 31],
              ["思政实践基地", 16],
              ["思政课程", 22],
              ["思政研究成果", 17],
              ["其他", 14],
            ],
            colors: ["#80CB4B", "#FFC808", "#FE8D37","#517FD9","#38CEC1"],
          },
        ],
      });
    },
	getMyChart6(value) {
      HighCharts.chart("type", {
        chart: {
          type: "pie",
          options3d: {
            enabled: true,
            alpha: 60,
            beta: 0,
          },
          backgroundColor: null,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: null,
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#fff",
            fontSize: "14",
          },
          width: 100, // 设置图例宽度
	        symbolHeight: 10, // 调整图例符号高度
	        symbolWidth: 10, // 调整图例符号宽度
	        symbolRadius: 0, // 调整图例符号圆角
          itemMarginTop: 10,
          align: "right", // 图例水平对齐方式（可选值：'left', 'center', 'right'）
          verticalAlign: "middle", // 图例垂直对齐方式（可选值：'top', 'middle', 'bottom'）
        },
        plotOptions: {
          pie: {
            size: value,
            showInLegend: true,
            allowPointSelect: true, //每个扇块能否选中
            depth: 30, //饼图的厚度
            borderWidth: 2, 
            borderColor: '#FFFFFF', // 设置边框颜色为白色
            dataLabels: {
              distance: 20, //控制饼图外面的线的长短,为负数时文本内容在饼图内部
              enabled: true, //是否显示饼图的线形tip
              formatter:function(color){
	              	console.log(this.point);
	                 return '<b style="color:'+this.point.color+';font-size:14px;">'+this.point.y+'%</b></br>'+this.point.name+"";
	            },
	            style: {
	                  color: "#fff",
	                  textOutline: "none",
	                  fontSize:14,
	            },
            },
          },
        },
        series: [
          {
            // size: 150,
            name: "使用占比",
            data: [
              ["省补贴", 10],
              ["其他来源", 10],
              ["学校自筹", 20],
              ["地方补贴", 60],
            ],
            colors: ["#80CB4B", "#FFC808", "#FE8D37","#517FD9"],
          },
        ],
      });
    },
    mgtdown(arr){
    	   var myChart = echarts.init(document.getElementById('mgt'));
	  	  let color = ['#FFD900', '#517FD9', '#FF7E00', '#00A1E4'];
				let data1 = [
				    { value: 120, name: '职业本科',value1:'2'},
				    { value: 20, name: '高职院校' ,value1:'50'},
				    { value: 156, name: '中职院校',value1:'212' },
				    { value: 33, name: '技工院校' ,value1:'10'},
				];
				data1.sort(function(a,b){
				    return a.value-b.value
				})
				color.splice(data1.length,data1.length-1);
				data1.map((item,index) => {
				    data1.push({ value: 0, name: '' });
				    color.push('transparent');
				});
				let option = {
				    backgroundColor: '',
				     title: {
				        text: '',
				    },
				    tooltip: {
				        show: false,
				    },
				    legend: {
				        icon: 'circle',
				        top: '10%',
				         textStyle: {
				            color: '#fff',
				        },
				    },
				    series: [
				        {
				            name: '玫瑰图',
				            type: 'pie',
				            startAngle:180,
				            radius: arr,
				            center: ['50%', '90%'],
				            roseType: 'area',
				            avoidLabelOverlap: false,
				            itemStyle: {
				                normal: {
				                    color: function (params) {
				                        return color[params.dataIndex]
				                    },
				                },
				            },
				            label: {
				                show: true,
				                position: 'outside',
				                fontSize:14,
				                formatter: function (params) {
//				                	  console.log(params);
				                    return params.data.name+":"+params.data.value+'/'+params.data.value1+"所";
				                },
				                color: '#fff',
				            },
				            labelLine: {
				                normal: {
				                    length: 10,
				                    length2: 10,
				                    show: true,
				                    lineStyle: {
				                        width: 1,
				                    },
				                },
				            },
				            data: data1,
				        },
				    ],
				};
					myChart.clear();
				myChart.setOption(option);
	  }
	}
}
</script>

<style lang="scss" scoped>
p{
	margin:0px;
	padding:0px;
}
.ztbox{
  height:auto;
  flex:1;
  width:100%;
	/*background: url("../../assets/images/bigdatas/banner.png") no-repeat;*/
  background-repeat: no-repeat;
  /*overflow: auto;*/
  background-size: 100% 100%;
  box-sizing: border-box;
  .ztcenter{
  	.centerlist{
  		 height:420px;
  		 display: flex;
  		 justify-content: space-between;
  		 margin-bottom:10px;
  		 .centerone{
  		 	  width:49%;
  		 	  height:auto;
  		 	  overflow: hidden;
  		 	  margin-bottom:10px;
  		 	  .onetitle{
  		 	  	 height:48px;
  		 	  	 background: url("../../assets/images/bigdatas/tbg.png") no-repeat;
  					 background-repeat: no-repeat;
  					 background-size: 100% 100%;
  					 padding-left:30px;
  					 line-height: 48px;
  					 font-weight: bold;
							font-size: 20px;
							color: #02F4F5;
							display: flex;
							align-items: center;
							
  		 	  }
  		 	  .onetitle1{
  		 	  	  background: url("../../assets/images/xin/szw6.png") no-repeat;
  		 	  	  background-repeat: no-repeat;
    			  background-size: 100% 100%;
  		 	  }
  		 	  .onebg{
  		 	  	 height:362px;
  		 	  	 background: url("../../assets/images/bigdatas/bbg.png") no-repeat;
  					 background-repeat: no-repeat;
  					 background-size: 100% 100%;
  					 padding:8px;
  					 box-sizing: border-box;
  					 .onetop{
  					 	  display: flex;
  					 	  justify-content: space-between;
  					 	  align-items: center;
  					 	  height:68px;
  					 	  width:100%;
  					 	  .topitem{
  					 	  	  width:19%;
  					 	  	  height:68px;
  					 	  	  background: url("../../assets/images/bigdatas/ibg.png") no-repeat;
				  					background-repeat: no-repeat;
				  					background-size: 100% 100%;
				  					display: flex;
				  					justify-content: flex-start;
				  					align-items: center;
				  					.span{
				  						width:40%;
				  						color: #FFFFFF;
				  						text-align:center;
				  						padding:0px 17px;
				  						box-sizing: border-box;
											/*line-height: 24px;*/
				  					}
				  					.topright{
				  						width:60%;
				  						padding:10px 0px;
				  						box-sizing: border-box;
				  						.righttop{
				  							font-weight: bold;
												font-size: 20px;
												color: #FFD70E;
												line-height: 24px;
												text-align:center;
												span{
													color: #fff;
													font-size: 14px;
												}
				  						}
				  						.rightbottom{
				  							text-align:center;
				  							font-size: 18px;
												color: #008ACA;
												line-height: 24px;
												text-align: center;
				  						}
				  					}
  					 	  }
  					 }
  					 
  					 .onebottom{
  					 	  height:288px;
  					 	  display:flex;
  					 	  justify-content: flex-start;
  					 	  .bottomleft{
  					 	  	width:55%;
  					 	  	height:100%;
  					 	  	
  					 	  }
  					 	  
  					 	  .onebox{
  					 	  	width:100%;
  					 	  	height:248px;
  					 	  }
  					 	  .bottomright{
  					 	  	width:45%;
  					 	  	height:100%;
  					 	  }
  					 }
  					 
  					 .bgzt{
  					 	width:100%;
  					 	height:100%;
  					 	display: flex;
  					 	justify-content: flex-start;
  					 	.ztleft{
  					 		width:30%;
  					 		max-width: 278px;
  					 		display: flex;
  					 		flex-direction: column;
  					 		justify-content: space-between;
  					 		.leftitem{
  					 			width:100%;
  					 			height:64px;
  					 			padding:10px 15px;
  					 			box-sizing: border-box;
  					 			background: url("../../assets/images/bigdatas/fbg.png") no-repeat;
				  				background-repeat: no-repeat;
				  				background-size: 100% 100%;
				  				display: flex;
				  				justify-content: space-between;
				  				align-items: center;
				  				.lefttext{
				  					font-size: 16px;
										color: #FFFFFF;
										span{
											font-weight: bold;
											font-size: 20px;
											color: #FFD70E;
										}
				  				}
				  				
  					 		}
  					 	}
  					 	.ztright{
  					 		width:70%;
  					 		height:100%;
  					 	}
  					 }
  		 	  }
  		 }
  	}
  	.centerlist1{
  		height:260px;
  		.onebg1{
  			height:202px!important;
  			display: flex;
  			justify-content: flex-start;
  			/*align-items: center;*/
  		}
  		.bg1-left{
  			 width:26%;
  			 max-width: 218px;
  			 padding-right:5px;
  			 box-sizing: border-box;
  			 .bg1-top{
  			 	 width:100%;
  			 	 height:44px;
  			 	 background: url("../../assets/images/bigdatas/gbg.png") no-repeat;
				   background-repeat: no-repeat;
				   background-size: 100% 100%;
				   display:flex;
				   justify-content: space-between;
				   align-items: center;
				   flex-wrap: wrap;
				   padding:0px 15px;
				   box-sizing: border-box;
				   .bg1-top-text{
				   	  font-size: 16px;
							color: #FFFFFF;
							span{
								color:#F7D014;
								font-size: 18px;
							}
				   }
  			 }
  			 .bg1-bottom{
  			 	  display: flex;
  			 	  justify-content: flex-start;
  			 	  flex-wrap: wrap;
  			 	  .bg1-bottom-item{
  			 	  	 width:50%;
  			 	  	 height:70px;
  			 	  	 /*margin:38px 0px;*/
  			 	  	 .bg1-bottom-img{
  			 	  	 	   width:90px;
  			 	  	 	   height:58px;
  			 	  	 	   background: url("../../assets/images/bigdatas/hbg.png") no-repeat;
				           background-repeat: no-repeat;
				           background-size: 100% 100%;
				           font-weight: bold;
										font-size: 20px;
										color: #fff;
										margin:2px auto 0px;
										text-align: center;
										line-height: 32px;
  			 	  	 }
  			 	  	 .bg1-bottom-text{
  			 	  	 	  font-size: 12px;
  			 	  	 	  line-height: 14px;
									color: #FFFFFF;
									text-align: center;
									  white-space: nowrap; /* 不换行 */
					    overflow: hidden; /* 隐藏超出部分 */
					    text-overflow: ellipsis; 
  			 	  	 }
  			 	  }
  			 }
  		 }
  		
  		.bg1-right{
  			width:74%;
  			height:100%;
  			border-left:1px solid #093076;
  		}
  		.onesj{
  			width:100%;
  			height:100%;
  		}
  	}
  }
   .lefttitle{
  					 	  	width:100%;
  					 	  	height:40px;
  					 	  	display: flex;
  					 	  	justify-content: flex-start;
  					 	  	align-items: center;
  					 	  	.leftspan{
  					 	  		font-size: 16px;
										color: #FFFFFF;
  					 	  	}
  }
  .zhlist{
  	width:100%;
  	display:flex;
  	flex-direction: column;
  	justify-content: space-between;
  	.zhitem{
  		 height:42px;
  		 background: url("../../assets/images/bigdatas/ser.png") no-repeat;
			 background-repeat: no-repeat;
			 background-size: 100% 100%;
			 display: flex;
			 justify-content: flex-start;
			 align-items: center;
			 padding:0px 15px;
			 box-sizing:border-box;
			 .zhimg{
			 	  width:19px;
			 	  height:18px;
			 	  margin-right:10px;
			 }
			 .zhspan1{
			 	font-weight: bold;
				font-size: 16px;
				color: #FFFFFF;
				white-space: nowrap; /* 不换行 */
				overflow: hidden; /* 隐藏超出部分 */
			  text-overflow: ellipsis; 
			  max-width:52%;
			 }
			 .zhspan2{
			 	font-weight: bold;
				font-size: 16px;
				color: #FFE8A3;
			 }
  	}
  	
  }
  .zhtleft{
  		 width:40%;
  		 height:100%;
  	}
  	.zhtright{
  		 width:60%;
  		 height:100%;
  	}
  .tables{
  	  width:100%;
  	 thead{
  	 	  tr{
  	 	  	background-color: #082569;
  	 	  	height:30px;
  	 	  	th{
  	 	  		width:25%;
  	 	  		height:30px;
  	 	  		line-height: 30px;
  	 	  		text-align: center;
  	 	  		font-size: 16px;
						color: #8298FB;
  	 	  	}
  	 	  }
  	 }
  	 tbody{
  	 	 tr{
  	 	 	 height:25px;
  	 	 	 border-bottom:1px solid #213E78;
  	 	 	 td{
  	 	 	 	 	width:25%;
  	 	  		height:25px;
  	 	  		line-height: 25px;
  	 	  		text-align: center;
  	 	  		font-size: 16px;
						color: #fff;
  	 	 	 }
  	 	 }
  	 }
  }
  @media screen and (max-width: 1440px) and (min-width: 1367px){
  	.span{
  		padding: 0 10px!important;
  	}
  	.onetitle,.onetitle1,.onetitle2,.bg1-bottom-img{
  		font-size:18px!important;
  	}
  	.zhspan1{
  		max-width: 45%!important;
  	}
  	.bg1-top-text,.zhspan1,.zhspan2{
  		font-size:13px!important;
  	}
  	.zhitem{
  		padding:0px 10px!important;
  	}
  }
  @media screen and (max-width: 1366px) {
  	.onetitle,.onetitle1,.onetitle2,.bg1-bottom-img{
  		font-size:16px!important;
  	}
  	.span{
  		font-size:10px!important;
  		padding: 0 10px!important;
  	}
  	.zhspan1{
  		max-width: 45%!important;
  	}
  	.bg1-top-text,.zhspan1,.zhspan2{
  		font-size:12px!important;
  	}
  	.lefttext{
  		font-size:14px!important;
  	}
  	.bg1-top{
  		padding:0px 5px!important;
  	}
  	.tables{
  	  width:100%;
  	 thead{
  	 	  tr{
  	 	  	background-color: #082569;
  	 	  	height:30px;
  	 	  	th{
  	 	  		width:25%;
  	 	  		height:30px;
  	 	  		line-height: 30px;
  	 	  		text-align: center;
  	 	  		font-size: 14px!important;
						color: #8298FB;
  	 	  	}
  	 	  }
  	 }
  	 tbody{
  	 	 tr{
  	 	 	 height:25px;
  	 	 	 border-bottom:1px solid #213E78;
  	 	 	 td{
  	 	 	 	 	width:25%;
  	 	  		height:25px;
  	 	  		line-height: 25px;
  	 	  		text-align: center;
  	 	  		font-size: 14px!important;
						color: #fff;
  	 	 	 }
  	 	 }
  	 }
  }
  }
}
::v-deep .ant-select-selection {
  background-color: #01297d;
  color: #fff;
  border-color: #2669e6;
}
::v-deep .ant-select-dropdown {
  background-color: #01297d;
  color: #fff;
}
::v-deep .ant-select-arrow {
  background-color: #01297d;
  color: #fff;
}
::v-deep .ant-radio-button-wrapper {
  color: #999;
  background-color: #0d308d;
  border-color: #ffffff00;
  border-radius: 0;
}
</style>

<style lang="scss">
.customClass {
  background: #01297d;
  .ant-select-dropdown-menu-item {
    background-color: #01297d;
    color: #fff;
    &:not(:last-child) {
      border-bottom: 1px solid #999;
    }
    &:hover:not(.ant-select-dropdown-menu-item-disabled) {
      background-color: #0f5bff;
    }
  }
}
</style>